const sysManageEn = {
  sysManageLang: {
    系统总览: 'System overview',
    批量添加: 'Bulk add',
    添加系统: 'Addition system',
    当需要添加的系统较多时可点击批量添加按钮批量添加请先: 'If a large number of systems need to be added, click the Batch Add button. (For batch addition, please ',
    下载Excel模板: 'download the Excel template',
    填写完成后再进行上传提交: ' first, fill it out and then upload and submit it)',
    请选择归属: 'Please select an affiliation',
    请输入内容例如EMS编号归属系统编号ICCID: 'Please enter content, such as EMS number, attribution, system number, ICCID',
    查询: 'Query',
    重置: 'Reset',
    批量操作: 'Batch operation',
    当前已选: 'Currently selected',
    项: '',
    取消: 'Cancel',
    批量分配: 'Batch allocation',
    序号: 'Serial Number',
    系统编号: 'System number',
    系统名称: 'System name',
    EMS编号: 'EMS number',
    ICCID: 'ICCID',
    归属状态: 'Attribution state',
    暂无归属: 'No attribution',
    电站: 'Power station',
    客户: 'Client',
    归属: 'Attribution',
    冷却方式: 'Type of cooling',
    额定功率: 'Rated power',
    标称电压: 'Nominal voltage',
    尺寸: 'Size',
    重量: 'Weight',
    操作: 'Operation',
    查看: 'Examine',
    修改: 'Modification',
    是否确认删除系统操作: 'Are you sure to delete the system operation?',
    删除: 'Delete',
    系统分配: 'System-assigned',
    是否确认撤回此次分配操作: 'Do you want to cancel this assignment?',
    系统撤回: 'Systematic withdrawal',
    控制配置: 'Control configuration',
    设备录入: 'Equipment input',
    暂无数据: 'No data available',
    基础信息: 'Basic information',
    请输入系统编号: 'Please enter the system number',
    自定义系统编号名称: 'Custom system number name',
    请输入EMS编号: 'Please enter the EMS number',
    规格参数: 'Specification parameter',
    请输入额定功率: 'Please enter the rated power',
    额定功率数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
    小数点后不允许超过1位: 'No more than 1 digits are allowed after the decimal point',
    额定容量: 'Rated capacity',
    请输入额定容量: 'Please enter the rated capacity',
    额定容量数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
    请选择冷却方式: 'Please select a type of cooling',
    请输入标称电压: 'Please enter the nominal voltage',
    标称电压数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
    请输入重量: 'Please enter weight',
    重量数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
    请输入尺寸长宽高: 'Please enter dimensions (L * W * H)',
    确定: 'Confirm',
    查看系统: 'View system',
    系统批量分配: 'System batch allocation',

    当前: 'At present',
    选择电站名称: 'Please select the name of the power station',
    厂家: 'Manufacturers',
    输入厂家编码: 'Enter manufacturer code',
    文件上传完成后点击提交按钮以完成导入: 'Once the file is uploaded, click the Submit button to complete the import',
    文件大小: 'File size',
    上传日期: 'Upload date',
    点击上传: 'Click to upload',
    拖拽到此区域: 'Drag to this area',
    重新上传: 'Re-upload',
    请上传Excel文件文件大小在1M内: 'Please upload the Excel file, the file size is less than 1 MB',
    文件大小不符合规则请上传Excel文件文件大小在1M内: 'The file size does not meet the rules. Please upload the Excel file. The file size must be less than 1 MB',
    全部: 'All',
    未归属: 'No owner',
    风冷: 'Air cooling ',
    液冷: 'Liquid cooling',
    其它: 'Others',
    无: 'No',
    小数点后不允许超过1位: 'No more than 1 digits are allowed after the decimal point',
    修改系统: 'Modified system',
    请选择分配电站: 'Please select a distribution power station！',
    系统已成功分配给: 'The system has been successfully assigned to the',
    请输入客户编码: 'Please enter client code',
    EMS系统批量导入模板: 'EMS system - Import templates in batches.xlsx',
    请上传格式内容正确文件: 'Please upload file with correct format content!',
    系统列表Excel已成功导入: 'The Excel system list has been imported successfully!',
    已成功导入: 'Successfully imported  ',
    条数据: ' pieces of data',
    失败: 'failed ',
    条: '  pieces',
    请下载文件查看失败原因: 'Please download the file to see the reason for the failure！',
    提示: 'Hint',

    系统列表Excel导入失败请检查后重新尝试: 'System list Excel import failed, please check and try again!',
    请使用模板文件的格式进行上传上传文件只能是xlsxlsx格式: 'Please use the template file format to upload, upload files can only be xls, xlsx format!',
    请使用模板文件的格式进行上传上传文件大小不可超过1M: 'Please use the template file format to upload, the size of the uploaded file cannot exceed 1M!',
    系统信息为空请重新上传: 'System information is empty, please upload again!',
    设备监控: 'Equipment monitoring',

    系统管理: '系统管理',
    默认开启能量管理下的手动能量控制防过载防逆流功能可选中或取消控制配置点击确认以下发:
      'By default, the functions of manual energy control, anti-overload, and anti-countercurrent under energy management are enabled. You can select or cancel the control configuration, and click OK to deliver!',
    引用配置: 'Reference configuration',
    系统控制: 'System control',
    手动控制: 'Manual',
    BMS二级保护: 'BMS Secondary protection',
    能量管理: 'Energy management',
    能量控制: 'Energy control',
    SOC参数设置: 'SOC parameter setting',
    过载保护: 'Overload protection',
    防逆流: 'Anti-reflux',
    防逆流时段: 'Anti-reflux time frame',
    PCS启停: 'PCS start-stop',
    PCS模式控制: 'PCS mode control',
    PCS并离网控制: 'PCS and off-grid control',
    二级保护参数设置: 'Secondary protection parameter settings',
    设备控制: 'Equipment control',
    空调: 'Air-conditioning',
    消防: 'Fire fighting',
    充电桩: 'Charging station',
    光伏: 'Photovoltaic',
    柴发: 'Diesel generator',
    空调启停: 'Air conditioner start-stop',
    空调工作模式设置: 'Air conditioner working mode',
    空调参数设置: 'Air conditioner parameter setting',
    TMS工作模式设置: 'TMS working mode setting',
    TMS参数设置: 'TMS parameter setting',
    消防启停: 'Fire start-stop',
    UPS启停: 'UPS start-stop',
    充电桩启停: 'Charging pile start-stop',
    BMS并离网: 'BMS and off-grid',
    BMS脱扣控制: 'BMS trip control',
    BMS软件复位: 'BMS Software reset',
    故障复位: 'Fault reset',
    光伏启停: 'Pv start-stop',
    光伏复位: 'Photovoltaic reset',
    DCDC启停控制: 'DCDC start and stop control',
    DCDC故障复位控制: 'DCDC fault reset control',
    柴发启停: 'Diesel generator start-stop',
    确认: 'Confirm',
    请选择要引用配置的系统引用后将会覆盖当前内容: 'Please select the system you want to reference the configuration, after the reference will overwrite the current content!',
    选择系统: 'Selection system',
    请选择: 'Please select',

    新增设备: 'New equipment added',
    添加设备后请填写设备信息其中序号和设备ID为必填项厂家和型号为非必填项:
      'Please fill in the equipment information after adding the equipment, where the serial number and equipment ID are required, and the manufacturer and model are not required.',
    是否确认删除当前设备: 'Whether to confirm deleting the current device?',
    型号: 'Model number',
    电表: 'Meter',
    设备ID: 'Device ID',
    调速器: 'Governor',
    外设: 'Peripheral',
    除湿器: 'Dehumidifier',
    环境监测: 'Environmental monitoring',
    光伏逆变器: 'PV Inverter',
    箱变: 'Box-type transformer',
    综合保护设备: 'Comprehensive protection equipment',
    请确认是否保存当前设备录入信息: 'Please confirm whether to save the current device input information!',
    请确认是否取消当前设备录入配置退出页面后录入信息不会保存需重新录入:
      'Please confirm whether to cancel the current device entry configuration. The input information will not be saved after exiting the page and needs to be re-entered！',
    是否要删除当前选择的设备: 'Whether the currently selected device should be deleted?',
    请选择要引用配置的系统引用后将会覆盖当前配置内容: 'Please select the system you want to reference the configuration, the reference will overwrite the current configuration content!',
    可选中设备后输入设备数量点击确认新增设备: 'After selecting the device, input the number of the device and click Confirm to add the device.',
    数量: 'Number',
    储能电表: 'Energy storage meter',
    电池堆: 'Battery stack ',
    电池簇: 'Battery Cluster',
    PCS: 'PCS',
    BMS: 'BMS',
    TMS: 'TMS',
    UPS: 'UPS',
    DCDC: 'DCDC',
    PV: 'PV',
    ATS: 'ATS',
    电网连接点电表_低压侧: 'Grid meter/Low side',
    电网连接点电表_高压侧: 'Grid meter/High side',
    负载电表: 'Load meter',
    储能监测电表: 'Energy storage monitoring meter',
    光伏电表: 'Photovoltaic meter',
    请输入: 'Please enter',
    只能输入数值: 'Numeric input only',
    字母数字下划线组成: 'Alphanumeric characters are underlined',
    设备ID长度为150: 'The device ID length is 1-50',
    输入的数量必须是整型数值: 'The quantity entered must be an integer value',
    信息不能为空: 'The information cannot be null',
    设备序号或者设备Id不能重复: 'Device serial numbers or device ids cannot be duplicated',
    设备录入成功: 'The device was entered successfully!',
    若填写电池堆数量电池堆下至少电池簇数量填1不能为空:
      'If the number of battery stack is filled in, at least the number of battery clusters under the battery stack is filled in 1, and it cannot be empty!'
  }
}
export default sysManageEn
